import { hasLs } from "@/ultis/Helper";

const state = {
   user: {}
};

const getters = {
   user(state) {
      return state.user;
   },
   isLoggedIn() {
      return !(state.user.guestId > 0) && state.user.userInfo ? true : false;
   }
};

const mutations = {
   USER_LOGIN(state, user) {
      // Guest:
      if (!user) {
         state.user = {};
         return;
      }
      state.user.guestId = user && user.guestId ? user.guestId : 0;
      state.user.guestName = user && user.guestName ? user.guestName : null;
      state.user.displayName = user && user.displayName ? user.displayName : null;
      state.user = { ...user };
   },

   USER_LOGOUT(state, user) {
      state.user.displayName = null;
      state.user.guestId = user && user.guestId ? user.guestId : 0;
      state.user.guestName = user && user.guestName ? user.guestName : null;
   }
};

const actions = {
   userLogin: ({ commit }, user) => {
      if (hasLs()) {
         localStorage.removeItem("currentUser");
         localStorage.setItem("currentUser", JSON.stringify(user));
      }
      commit("USER_LOGIN", user);
   },
   userLogout: ({ commit }, user) => {
      if (hasLs()) {
         localStorage.removeItem("currentUser");
         localStorage.setItem("currentUser", JSON.stringify(user));
      }
      commit("USER_LOGOUT", user);
   }
};

export default {
   state,
   getters,
   mutations,
   actions
};
